import { BRAND, brandAlpha } from '../theme/brandTokens';

const stockChipSx = {
  fontWeight: 600,
};

export const getStockStatus = ({ stockOnHand, contentQuantity, lowStockThreshold }) => {
  const onHand = Number(stockOnHand) || 0;
  const content = Number(contentQuantity) > 0 ? Number(contentQuantity) : 1;

  if (onHand < 0) {
    return 'negative';
  }

  if (onHand < content) {
    return 'out';
  }

  if (lowStockThreshold != null && lowStockThreshold !== '' && onHand <= Number(lowStockThreshold)) {
    return 'low';
  }

  return 'ok';
};

export const getStockStatusChipSx = (status) => {
  if (status === 'negative' || status === 'out') {
    return {
      ...stockChipSx,
      backgroundColor: brandAlpha('text', 0.08),
      color: BRAND.text,
      border: `1px solid ${BRAND.line}`,
    };
  }

  if (status === 'low') {
    return {
      ...stockChipSx,
      backgroundColor: brandAlpha('accent', 0.08),
      color: BRAND.accentText,
      border: `1px solid ${brandAlpha('accent', 0.4)}`,
    };
  }

  return {
    ...stockChipSx,
    backgroundColor: BRAND.primary,
    color: BRAND.onPrimary,
  };
};

export const availablePackages = (product) => {
  const content = Number(product?.contentQuantity) > 0 ? Number(product.contentQuantity) : 1;
  const onHand = Number(product?.stockOnHand);
  if (!Number.isFinite(onHand)) {
    return null;
  }

  return Math.floor((onHand + 1e-9) / content);
};
